export enum CompareStatus {
    PENDING = 0,
    COMPLETED = 1,
    FAILED = 2,
}

export const parseCompareStatus = (status: CompareStatus): string => {
    switch (status) {
        case CompareStatus.PENDING:
            return 'Pending';
        case CompareStatus.COMPLETED:
            return 'Completed';
        case CompareStatus.FAILED:
            return 'Failed';
        default:
            return '';
    }
};
